module.exports = __webpack_public_path__ + "static/media/logo-white.a3f607fd.svg";